import { Navigate, Outlet } from 'react-router-dom';
import { useLocalStorage } from './store/storage';

function Logout(){
	useLocalStorage('user', null);
    return <Navigate to="/login" />;
}

export default Logout;